// extracted by mini-css-extract-plugin
export default {"container":"image-modal_container__DHYle","actions":"image-modal_actions__AyebT"};